import { render, staticRenderFns } from "./AppBuildPlugins.vue?vue&type=template&id=66aef7d0&scoped=true&"
import script from "./AppBuildPlugins.vue?vue&type=script&lang=js&"
export * from "./AppBuildPlugins.vue?vue&type=script&lang=js&"
import style0 from "./AppBuildPlugins.vue?vue&type=style&index=0&id=66aef7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aef7d0",
  null
  
)

export default component.exports